module.exports = __webpack_public_path__ + "static/media/leadscore.326f46b7.png";